'use strict'
module.exports = {
  NODE_ENV: '"us"',

	// URLs
	APP_BASEURL: '"https://hermes-elysium.protopia.co/"',
	API_BASEURL: '"https://api-elysium.protopia.co/"',
	APP_REDIRECT_URL: '"https://protopia.co/maintenance"',
	CORE_API_URL: '"https://agw-elysium.protopia.co"',
	// Auth0
	AUTH0_DOMAIN: '"protopia.auth0.com"',
	AUTH0_CLIENT: '"4eamp9fZyWY0BSnRCl8OVrC1vYDyJBG8"',
	AUTH0_CALLBACK: '"https://hermes-elysium.protopia.co/callback"',
	// APIs
	NLP_API_KEY: '"AIzaSyAF5uU3sw03sDV-deyZllXY8BqgtG2yI2Y"',
	// Branding
	LOGO_URL: '"https://storage.googleapis.com/protopia/logos/logo_protopia_xs.png"',

	// LinkedIn Integration
	LINKEDIN_CLIENT_ID: '""',
	LINKEDIN_CLIENT_SECRET: '""',
	LINKEDIN_REDIRECT_URI: '"https://hermes-elysium.protopia.co/thank-you"',
	LINKEDIN_STATE_KEY: '"elysium"',
	// App Settings
	DEFAULT_EMAIL: '"team@protopia.co"',
	RANDOM_INTEREST_COUNT: 15,
	ADDITIONAL_PARAM_FRIENDLY_COUNT: 12,
	APP_REDIRECT_TIME: 10000,
	CAPTCHA_SITEKEY: '6LeiihAuAAAAAI4Z2JiU3OGSSfCjgJbjVOt3AWDZ',
  VUE_APP_PROCESS_DASHBOARD_URL:'"https://hermes-elysium.protopia.co/process-dashboard"',
	// Public base of the recruiting wizard.
	RECRUITING_BASEURL: '"https://opportunities-elysium.protopia.co"'
}



//////////////////
// WEBPACK FOOTER
// ./config/us.env.js
// module id = xUeO
// module chunks = 1